import React, { useRef } from 'react'
import Icon from '@components/atoms/Icon'

interface AccordionContent {
  title: string
  content: string
  collapse_class: string
}

export interface FAQData {
  accordions: AccordionContent[]
}

const FAQ: React.FC<FAQData> = ({ accordions }) => {
  const detailsRefs = useRef<Array<HTMLDetailsElement | null>>([])

  const handleToggle = (index: number) => {
    detailsRefs.current.forEach((details, i) => {
      if (details && i !== index) {
        details.open = false
      }
    })
  }

  if (!accordions || accordions.length === 0) {
    console.log('Section data: empty for FAQ')
    return null
  }

  return accordions.length === 0 || accordions.every((acc) => !acc.title && !acc.content) ? null : (
    <div className="border-t border-solid border-black">
      {accordions
        .filter((accordion) => accordion.title && accordion.content)
        .map((accordion, index) => (
          <div key={index} className="block text-left border-b border-solid border-black">
            <details
              ref={(el) => (detailsRefs.current[index] = el)}
              className={`${accordion.collapse_class} group/accordion py-4 lg:py-5 transition-max-height duration-500 ease-out overflow-hidden`}
              onToggle={(e) => {
                if (e.target instanceof HTMLDetailsElement && e.target.open) {
                  handleToggle(index)
                }
              }}
            >
              <summary className="[&::-webkit-details-marker]:hidden flex cursor-pointer flex-row items-center justify-between font-semibold text-black body-md">
                <span className="text-black body-md">{accordion.title}</span>
                <Icon
                  name="icon-arrow-down"
                  className="transition-transform duration-500 stroke-black group-open/accordion:rotate-180"
                />
              </summary>
              <div className="group-open/accordion:max-h-96">
                <div className="text-black body-md pt-5" dangerouslySetInnerHTML={{ __html: accordion.content }}></div>
              </div>
            </details>
          </div>
        ))}
    </div>
  )
}

export default FAQ
